/**
 * @param {Any} val
 * @returns {Boolean}
 */
const parseBoolean = val =>
  val ? true : false;

export default parseBoolean;
